// Copyright (c) 2016 Deere & Company

import Dealer from '@deere/cps-it.warranty-model-factory/lib/dealer';
import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import t from 'tcomb';

const PipSearchFacets = t.struct({
    dealerAccountsFacet: t.struct({
        allowedDealers: t.list(Dealer),
        isInitialLoad: t.Boolean,
        selectedDealers: t.list(Dealer)
    }),
    pipTypesFacet: t.struct({
        allowedTypes: t.list(KeyValuePair),
        isInitialLoad: t.Boolean,
        selectedTypes: t.list(KeyValuePair)
    })
}, 'PipSearchFacets');

export const getDefaultState = () =>
    new PipSearchFacets({
        dealerAccountsFacet: {
            allowedDealers: [],
            isInitialLoad: true,
            selectedDealers: []
        },
        pipTypesFacet: {
            allowedTypes: [],
            isInitialLoad: true,
            selectedTypes: []
        }
    });

export default PipSearchFacets;



// WEBPACK FOOTER //
// ./src/pip/pip-search/state/facets.js